import { useEffect, useState } from 'react';
import router from 'next/router';
import { useUser } from '@store/hooks/useUser';
import { AuthenticationType } from '@store/contexts/UserContext';
import { Box } from '@yoweb/ui/components/Box';
import { Button } from '@yoweb/ui/components/buttons/Button';
import { AsyncModal } from '@yoweb/ui/components/Modal/AsyncModal';
import { useTranslation } from '@yoweb/next-i18next';
import { useExternalConfig } from '@store/contexts/ExternalConfig';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var AuthGuard = function AuthGuard(_ref) {
  var requiredAuthType = _ref.authType;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var _useUser = useUser(),
      isLoading = _useUser.isLoading,
      isAuthenticated = _useUser.isAuthenticated,
      actualAuthType = _useUser.type;

  var _useState = useState(false),
      sessionExpired = _useState[0],
      setSessionExpired = _useState[1];

  var _useState2 = useState(false),
      isReloading = _useState2[0],
      setIsReloading = _useState2[1];

  var _useExternalConfig = useExternalConfig(),
      env = _useExternalConfig.env;

  useEffect(function () {
    if (isLoading) {
      return;
    } // Session expired if we're not authenticated or semi authenticated, but auth0 authentication is required


    if (!isAuthenticated && requiredAuthType === 'auth0') {
      return setSessionExpired(true);
    } // Session expired if we don't have any session, but a semi session is expected


    if (actualAuthType === AuthenticationType.unauthenticated && requiredAuthType === 'semi') {
      return setSessionExpired(true);
    }

    setSessionExpired(false);
  }, [isLoading, actualAuthType, requiredAuthType, isAuthenticated]);

  if (!requiredAuthType || requiredAuthType === 'embed' || env === 'test') {
    return null;
  }

  return /*#__PURE__*/_jsxs(AsyncModal, {
    title: t('session-expired-title'),
    isOpen: sessionExpired,
    hasCloseButton: false,
    shouldCloseOnEsc: false,
    testId: "session-expired-modal",
    children: [t('session-expired-text'), /*#__PURE__*/_jsx(Box, {
      display: "flex",
      flexDirection: {
        _: 'column',
        md: 'row'
      },
      mt: {
        _: 'normal3'
      },
      justifyContent: {
        _: 'flex-end'
      },
      children: /*#__PURE__*/_jsx(Button, {
        onClick: function onClick() {
          setIsReloading(true);
          router.reload();
        },
        isLoading: isReloading,
        "data-testid": "session-expired-button",
        children: t('session-expired-button')
      })
    })]
  });
};

export default AuthGuard;